<template>
  <div>
    <PageHeader>
      <template v-slot:header>等級設定</template>
      <template v-slot:annotation>
        組織内の等級とシステムのアクセスレベルの設定をします
      </template>
    </PageHeader>

    <v-row>
      <v-col cols="6" sm="6" md="4" lg="2">
        <Button @click="onClickGradeEditOpen(null)" color="primary"
          >新規追加</Button
        >
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          @click:row="onClickGradeEditOpen"
          :loading="loading"
          loading-text="読み込み中..."
          no-data-text="等級設定は見つかりませんでした。新規追加ボタンより等級を設定してください。"
        >
          <template v-slot:[`item.IS_ACTIVE`]="{ item }">
            <span v-if="item.IS_ACTIVE">使用中</span>
            <span v-else>使用停止</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <Loader :loading="loading" />
    <GradeEdit ref="edit" @edit="editGradeInfo" @closeEdit="closeEdit" />
    <DialogMessage ref="dialog" />
  </div>
</template>

<script>
import GradeEdit from './GradeEdit.vue';
import axios from 'axios';
import config from '../../../const.js';
import message from '../../../message.js';
import { getSessionStorageItem } from '../../../common.js';

export default {
  components: { GradeEdit },

  data() {
    return {
      loading: false,
      items: [],

      headers: [
        {
          text: '表示順',
          align: 'left',
          value: 'SHOW_ORDER',
          width: '15%',
        },
        {
          text: '等級名称',
          align: 'left',
          value: 'GRADE_NAME',
        },
        {
          text: 'ユーザーランク',
          align: 'left',
          value: 'USER_RANK_NAME',
        },
        {
          text: '使用状態',
          align: 'left',
          value: 'EXPIRATION_NAME',
        },
      ],
    };
  },

  created() {
    this.getGrade();
  },

  methods: {
    onClickGradeEditOpen(item) {
      // 等級情報編集画面を表示
      if (item == null) {
        this.$refs.edit.open(null, { color: 'red' });
      } else {
        this.$refs.edit.open(item, { color: 'red' });
      }
    },
    editGradeInfo() {
      // 等級情報取得
      this.getGrade();
    },
    async getGrade() {
      this.loading = true;

      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      let vm = this;

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/grade/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 等級データ取得
          vm.items = response.data;
          for (var i = 0; i < this.items.length; i++) {
            // ユーザランク
            if (this.items[i].USER_RANK == config.USER_RANK_TOP) {
              this.items[i].USER_RANK_NAME = userInfo.USER_RANK_NAME_1;
            } else if (this.items[i].USER_RANK == config.USER_RANK_M) {
              this.items[i].USER_RANK_NAME = userInfo.USER_RANK_NAME_2;
            } else if (this.items[i].USER_RANK == config.USER_RANK_S) {
              this.items[i].USER_RANK_NAME = userInfo.USER_RANK_NAME_3;
            } else if (this.items[i].USER_RANK == config.USER_RANK_J) {
              this.items[i].USER_RANK_NAME = userInfo.USER_RANK_NAME_4;
            } else if (this.items[i].USER_RANK == config.USER_RANK_E) {
              this.items[i].USER_RANK_NAME = userInfo.USER_RANK_NAME_5;
            }

            //使用状態
            if (this.items[i].EXPIRATION == config.USE_IN) {
              this.items[i].EXPIRATION_NAME = config.USE_IN_NAME;
            } else if (this.items[i].EXPIRATION == config.USE_STOP) {
              this.items[i].EXPIRATION_NAME = config.USE_STOP_NAME;
            }
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },

    edit(item = null) {
      this.$refs.edit.open(item);
    },

    closeEdit() {
      this.getGrade();
    },
  },
};
</script>
